import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "description", "checked", "disabled", "onChange", "labelTooltip", "labelTooltipPlacement", "className", "disabledToggleTip", "loading", "dataTestId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { Switch } from '@snack-uikit/toggles';
import { Tooltip } from '@snack-uikit/tooltip';
import { parseKeyToDataTest } from '../../../../utils';
import { ObjectDecorator } from '../../ObjectDecorator';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SwitchRow(_ref) {
  var label = _ref.label,
    description = _ref.description,
    checked = _ref.checked,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    labelTooltip = _ref.labelTooltip,
    labelTooltipPlacement = _ref.labelTooltipPlacement,
    className = _ref.className,
    disabledToggleTip = _ref.disabledToggleTip,
    loading = _ref.loading,
    dataTestId = _ref.dataTestId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var handleChange = function handleChange() {
    return !disabled && onChange(!checked);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.code === 'Enter' || e.code === 'Space') {
      handleChange();
    }
  };
  var toggle = /*#__PURE__*/_jsx(Switch, {
    size: "m",
    checked: checked,
    disabled: disabled,
    "data-pointer": true,
    showIcon: false,
    tabIndex: -1,
    loading: loading
  });
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: cn(styles.switchRow, className),
    role: "switch",
    "aria-checked": checked,
    tabIndex: disabled ? -1 : 0,
    onClick: handleChange,
    onKeyDown: handleKeyDown,
    "data-disabled": disabled || undefined,
    "data-loading": loading || undefined,
    "data-checked": checked || undefined,
    "data-mobile": true,
    "data-test-id": dataTestId
  }, extractSupportProps(rest)), {}, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.headline,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.titleLayout,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.titleWrapper,
          "data-test-id": parseKeyToDataTest('toggle', 'title'),
          children: /*#__PURE__*/_jsx(ObjectDecorator, {
            label: label,
            labelTooltip: labelTooltip,
            labelTooltipPlacement: labelTooltipPlacement
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.wrap,
        children: disabled && disabledToggleTip ? /*#__PURE__*/_jsx(Tooltip, {
          tip: disabledToggleTip,
          triggerClassName: styles.switchRowWrapper,
          children: toggle
        }) : toggle
      })]
    }), description && /*#__PURE__*/_jsx("span", {
      className: styles.description,
      children: description
    })]
  }));
}